<template>
  <div>
    <button @click="showModal = true" class="inline-flex items-center text-base md:text-lg font-semibold hover:text-primary group">{{ button }}

      <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6">
      <path d="M12.6636 19.8633C12.2731 20.2538 12.2731 20.887 12.6636 21.2775C13.0541 21.6681 13.6873 21.6681 14.0778 21.2775L12.6636 19.8633ZM20.5703 13.3708L21.5703 13.3708C21.5703 12.8185 21.1226 12.3708 20.5703 12.3708V13.3708ZM14.3992 12.3708C13.8469 12.3708 13.3992 12.8185 13.3992 13.3708C13.3992 13.9231 13.8469 14.3708 14.3992 14.3708L14.3992 12.3708ZM19.5703 19.5419C19.5703 20.0942 20.0181 20.5419 20.5703 20.5419C21.1226 20.5419 21.5703 20.0942 21.5703 19.5419H19.5703ZM14.0778 21.2775L21.2775 14.0779L19.8632 12.6637L12.6636 19.8633L14.0778 21.2775ZM14.3992 14.3708L20.5703 14.3708L20.5703 12.3708L14.3992 12.3708L14.3992 14.3708ZM19.5703 13.3708L19.5703 19.5419H21.5703L21.5703 13.3708L19.5703 13.3708Z" class="fill-current"/>
      <circle cx="16.9706" cy="16.9707" r="11" transform="rotate(-45 16.9706 16.9707)" class="stroke-current" stroke-width="2"/>
    </svg>
    </button>


    <vue-final-modal
        v-slot="{ params, close }"
        v-model="showModal"
        classes="flex justify-center items-center"
        content-class="relative flex flex-col max-h-full mx-auto max-w-2xl px-4 pb-4 pt-12 md:p-16 bg-white"
    >
    <span class="text-xl font-bold mb-6 text-left">
      {{ title }}
    </span>
      <div class="flex-grow overflow-y-auto">

          <slot></slot>


      </div>

      <button class="absolute top-4 right-4 items-center justify-center w-10 h-10 inline-flex" @click="close"><span class="leading-none text-2xl md:text-3xl h-6 w-6">&times;</span></button>
    </vue-final-modal>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    button: {
      type: String,
      required: true
    },
  },
  data: () => ({
    showModal: false
  }),
  methods: {
    cancel(close) {
      // some code...
      close()
    }
  }
}
</script>
